import * as angular from "angular";
import * as _ from "lodash";
import {PriceType} from "../types/price.type";
import {PriceMethodType} from "../types/price-method.type";
import {AccountRequests} from "../../account/services/account-requests.service";
import {IQService} from "angular";
import {PricePlanBundleRequestsService} from "./price-plan-bundle-requests.service";
import {ProgramLocationType} from "../types/program-location.type";
import {
  ServiceFieldValidation,
  ServiceValidationLevel,
  ServiceValidationTemplateModel
} from "../models/service-validation-template.model";
import {SplitService} from "../../commons/services/split-service.service";
import {PricePlanAlertsService} from "./price-plan-alerts.service";
import {BatchRequestsService} from "../../batch/services/batch-requests.service";
import {ProgramImportType} from "../constants/program-import.const";

export class PricePlanDialogService {

  public programLocationTypes: typeof ProgramLocationType = ProgramLocationType;

  constructor(private $mdDialog, private $q: IQService, private $filter, private accountRequests: AccountRequests,
              private pricePlanBundleRequestsService: PricePlanBundleRequestsService, private splitService:SplitService, private moment, private $log, private uiGmapGoogleMapApi,
              private pricePlanConstant, private pricePlanAlertsService: PricePlanAlertsService, private IAMPermissions,
              private batchRequestsService: BatchRequestsService) {
  }

  /**
   * PRD-1726 - "Upload <program section>" modal. Resolves with the validated rows
   * (ImportVerification[]) returned by /{importerPath}/validate so the import view can show them
   * before anything is written.
   */
  showUploadProgramSettingsDialog(event: Event, importType: ProgramImportType, schemas?: any[]) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/upload-program-settings-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: false,
      fullscreen: true,
      controller: function ($scope) {
        $scope.loading = false;
        $scope.file = undefined;
        $scope.schemaId = undefined;
        $scope.validationError = undefined;
        $scope.validationDetail = undefined;
        $scope.entityLabel = importType.label;
        $scope.schemaOptionsWrapper = {
          list: _.map(schemas || [], (schema) => {
            return {id: schema.id, name: schema.schemaName};
          }),
          propertyRef: 'name'
        };

        $scope.cancel = self.$mdDialog.cancel;

        $scope.onSelectSchema = (schemaId) => {
          $scope.schemaId = schemaId;
          $scope.validationError = undefined;
          $scope.validationDetail = undefined;
        };

        $scope.onAddFile = (file) => {
          $scope.file = file;
          $scope.validationError = undefined;
          $scope.validationDetail = undefined;
        };

        $scope.onUpload = () => {
          if (!$scope.file) {
            $scope.validationError = 'Please select a file to upload';
            return;
          }

          $scope.loading = true;
          $scope.validationDetail = undefined;

          self.batchRequestsService.validateAgentAssignments(importType.importerPath, $scope.file, $scope.schemaId)
            .then((rows: any) => {
              self.$mdDialog.hide(rows || []);
            })
            .catch((error) => {
              $scope.validationError = 'Failed to validate the uploaded file';
              // The server explains rejections (too many rows, unreadable file, unknown schema) in
              // `more_info`, while `message` only names the error category.
              const detail = _.get(error, 'more_info') || _.get(error, 'message');
              $scope.validationDetail = _.isString(detail) ? detail : undefined;
              self.$log.error('Failed to validate program settings excel, ' +
                'pricePlanDialogService@showUploadProgramSettingsDialog', error);
            })
            .finally(() => {
              $scope.loading = false;
            });
        };
      }
    });
  }

  createTemplate(event) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.templateName = undefined;

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.templateName);
            }
          }
        }

      },
      template: require('./../views/dialogs/create-program-template-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createChildPricePlan(event) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.childPricePlanName = '';
        $scope.doRedirect = true;

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////

        $scope.ok = () => {
          if ($scope.childPricePlanName) {
            self.$mdDialog.hide({
              name: $scope.childPricePlanName,
              doRedirect: $scope.doRedirect
            });
          }
        }

      },
      template: require('./../views/dialogs/create-child-price-plan.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }


  duplicateBundle(event, bundle) {
    const self = this;
    return this.$mdDialog.show({
      controller: function ($scope) {

        $scope.originalBundleName = bundle.name;
        $scope.duplicatedPricePlanName = '';

        $scope.cancel = self.$mdDialog.cancel;

        //////////////////////

        $scope.ok = () => {
          if ($scope.duplicatedPricePlanName) {
            self.$mdDialog.hide($scope.duplicatedPricePlanName);
          }
        }

      },
      template: require('./../views/dialogs/duplicate-price-plan-bundle.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editPricePlanBundle(event, bundle, accountId) {
    if (accountId) {
      return this.editAccountBundle(event, bundle, accountId);
    }
    return this.editBundle(event, bundle);
  }


  editProgram(event?, bundle?, isAccount?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-program-dialog.html').default,
      controller: ['$scope', function ($scope) {

        $scope.bundle = angular.copy(bundle);
        $scope.hasAtLeastOneActivePricePlan = true;
        $scope.isAccount = isAccount;
        $scope.isShowSetDefaultAction = false;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.setProgramAsDefault = (program) => {
          $scope.bundle.defaultPricePlanProgramType = program;
        }

        $scope.update = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.bundle);
            }
          }
        }

        $scope.pricePlanChanged = () => {
          $scope.hasAtLeastOneActivePricePlan = !!_.find($scope.bundle.entryList, (pricePlan) => {
            return pricePlan.enabled;
          });
        }


      }],
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }


  changeProgram(event, currentProgram) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/change-program-dialog.html').default,
      controller: ['$scope', function ($scope) {

        $scope.programList = [];
        $scope.currentProgram = currentProgram;
        $scope.selectedProgram = angular.copy(currentProgram);

        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.onProgramSelect = (selectedProgram) => {
          $scope.selectedProgram = selectedProgram;
        }

        $scope.update = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.selectedProgram);
            }

          } else {
            self.$log.error('Form resolved to undefined!. \n' +
              '--> agentDialogService@editUserResidentialAddress@confirm')
          }
        }

        $scope._getAllPrograms = () => {
          $scope.loading = true;
          self.pricePlanBundleRequestsService.getAllBundles()
            .then((programList) => {
              $scope.programList = programList;
            })
            .catch((error) => {
              self.$log.error(error);
            })
            .finally(() => {
              $scope.loading = false;
            })
        }

        //Init Programs
        $scope._getAllPrograms();


      }],
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editAccountBundle(event, bundle, accountId) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-account-price-plan-bundle-dialog.tmpl.html').default,
      controller: ['$scope', function ($scope) {

        $scope.bundle = angular.copy(bundle);
        $scope.bundles = [];
        $scope.selectedBundle = '';
        $scope.searchText = '';
        $scope.selectedPlaceholder = bundle.name;
        $scope.doChange = false;
        $scope.loading = false;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.init = () => {
          self.pricePlanBundleRequestsService.getAllBundles().then(
            (bundles) => {
              $scope.bundles = bundles;
            }
          );
        }

        $scope.init();

        $scope.nameChangeCheck = () => {
          $scope.nameChanged = !_.isEqual(bundle.name, $scope.bundle.name)
        }

        $scope.bundleChanged = (selectedBundle) => {
          $scope.doChange = !_.isEqual(selectedBundle, bundle) && !_.isUndefined(selectedBundle);
          $scope.bundle = selectedBundle;
        }

        $scope.querySearch = (query) => {
          return self.$filter('filter')($scope.bundles, query);
        }

        $scope.update = () => {
          if ($scope.doChange) {
            $scope.loading = true;
            self.accountRequests.setAccountPricePlanBundle(accountId, $scope.selectedBundle.id).then(
              (pricePlanBundleUser) => {
                const pricePlanBundle = pricePlanBundleUser.pricePlanBundle;
                _.merge(pricePlanBundle.entryList, $scope.bundle.entryList);
                $scope.loading = false;
                self.$mdDialog.hide(pricePlanBundle);
              }
            );
          } else {
            $scope.loading = false;
            self.$mdDialog.hide($scope.bundle);
          }
        }


      }],
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  editBundle(event, bundle) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-price-plan-bundle-dialog.tmpl.html').default,
      controller: function ($scope) {

        $scope.bundle = angular.copy(bundle);
        $scope.hasAtLeastOneActivePricePlan = true;

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.pricePlanChanged = () => {
          $scope.hasAtLeastOneActivePricePlan = !!_.find($scope.bundle.entryList, (pricePlan) => {
            return pricePlan.enabled;
          });
        }

        $scope.update = () => {
          self.$mdDialog.hide($scope.bundle);
        }
      },
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true
    });
  }

  createProgramType(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-program-type-dialog.html').default,
      controller: function ($scope, pricePlanConstant) {
        $scope.availablePriceTypesByMethod = pricePlanConstant.availableProgramPriceTypesByMethod;
        $scope.header = 'Create New Program Type';
        $scope.action = 'Create';
        $scope.isCreate = true;
        // $scope.priceTypes = Object.values(PriceType);
        $scope.priceMethodTypes = Object.values(PriceMethodType);

        $scope.program = {
          priceMethodType: PriceMethodType.ServiceAreas,
          priceType: PriceType.ByDistance,
          code: undefined
        };
        $scope.enabled = {
          value: true
        };
        $scope.existingProgramCodes = Object.values(self.splitService.getProgramCodesMap());
        $scope.isSuperOwner = self.IAMPermissions.hasRole('super.owner');


        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onPricingMethodChanged = () => {
          _.unset($scope.program, 'priceType');
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const isProgramCodeUsed = $scope.existingProgramCodes.some((item) => {
                return item === $scope.program.code;
              });

              if (isProgramCodeUsed) {
                self.pricePlanAlertsService.programCodeExistsError();
              } else {
                self.$mdDialog.hide({program: $scope.program, enabled: $scope.enabled.value});
              }
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editProgramType(event, program) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-program-type-dialog.html').default,
      controller: function ($scope, pricePlanConstant) {

        $scope.header = 'Update Program Type';
        $scope.action = 'Update';

        $scope.priceMethodTypes = Object.values(PriceMethodType);
        $scope.availablePriceTypesByMethod = pricePlanConstant.availableProgramPriceTypesByMethod;

        $scope.program = angular.copy(program);
        $scope.isPriceDisabled = true;
        $scope.existingProgramCodes = Object.values(self.splitService.getProgramCodesMap());
        $scope.isSuperOwner = self.IAMPermissions.hasRole('super.owner');

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              const programCodeMap = self.splitService.getProgramCodesMap();
              const isProgramCodeUsed = $scope.existingProgramCodes.some((item) => {
                return !programCodeMap[$scope.program.id] && (item === $scope.program.code);
              });

              if (isProgramCodeUsed) {
                self.pricePlanAlertsService.programCodeExistsError();
              } else {
                self.$mdDialog.hide({program: $scope.program, enabled: $scope.enabled?.value});
              }
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  addTimeSlot(event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-time-slot-dialog.html').default,
      controller: function ($scope, commonsConstants) {

        $scope.header = 'Create Time Slot';
        $scope.action = 'Create';

        $scope.days = commonsConstants.dayArray;

        $scope.timeSlotOptions = {
          hours: [],
          minutes: [0, 30]
        };

        //Hours
        for (var hour = 0; hour <= 23; hour++) {
          $scope.timeSlotOptions.hours.push(hour);
        }

        //Days
        $scope.selectedDays = {
          from: $scope.days[0],
          to: $scope.days[0]
        };

        //Time
        $scope.selectedTime = {
          fromHour: undefined,
          fromMinute: undefined,
          toHour: undefined,
          toMinute: undefined
        };

        $scope.multiplDays = {
          enabled: false
        };

        $scope.timeSlot = {
          dow: [],
          startRecurring: undefined,
          startHour: undefined,
          startMinute: undefined,
          totalDurationInMillis: undefined,
          freq: 'WEEKLY',
          timezone: self.splitService.getTimeZone(),
          gap: undefined,
          // end: undefined,
          // start: undefined,
          // startTime: undefined,
          // endTime: undefined,
          // durationInMillis: undefined
        };

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.timeValidationCheck = () => {
          if (!$scope.multiplDays.enabled) {
            $scope.selectedDays.to = $scope.selectedDays.from;
          }

          const fromDay = self.moment().day($scope.selectedDays.from);
          const toDay = self.moment().day($scope.selectedDays.to);

          if (!$scope.multiplDays.enabled || fromDay >= toDay) {
            if ($scope.selectedTime.fromHour > $scope.selectedTime.toHour ||
              (_.isEqual($scope.selectedTime.fromHour, $scope.selectedTime.toHour) && $scope.selectedTime.fromMinute > $scope.selectedTime.toMinute)) {
              $scope.selectedTime.toHour = $scope.selectedTime.fromHour;
              $scope.selectedTime.toMinute = $scope.selectedTime.fromMinute;
            }
          }

        }

        $scope.onMultipleDaysChange = (enabled) => {
          $scope.selectedDays.to = $scope.selectedDays.from;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.timeSlot.startRecurring = $scope._getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
              $scope.timeSlot.startHour = $scope.selectedTime.fromHour;
              $scope.timeSlot.startMinute = $scope.selectedTime.fromMinute;
              $scope.timeSlot.totalDurationInMillis = $scope._getDurationInMillis();
              $scope.timeSlot.byWeekDay = [$scope.selectedDays.from.substring(0, 2)];

              // $scope.timeSlot.start = _getHour($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute);
              // $scope.timeSlot.end = _getHour($scope.selectedTime.toHour, $scope.selectedTime.toMinute);
              // $scope.timeSlot.startTime = _getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
              // $scope.timeSlot.endTime = _getTimeStamp($scope.selectedTime.toHour, $scope.selectedTime.toMinute, $scope.selectedDays.to);
              // $scope.timeSlot.byWeekDay = [$scope.selectedDays.from.substring(0, 2)];
              self.$mdDialog.hide($scope.timeSlot);
            }

          }
        }

        $scope._getHour = (hour, minute) => {
          return ("0" + hour).slice(-2) + ':' + ("0" + minute).slice(-2);
        }

        $scope._getTimeStamp = (hour, min, day) => {
          return self.moment().day(day).set({'hour': hour, 'minute': min, 'second': 0, 'millisecond': 0}).valueOf();
        }

        $scope._getDurationInMillis = () => {
          return $scope._getTimeStamp($scope.selectedTime.toHour, $scope.selectedTime.toMinute, $scope.selectedDays.to) - $scope._getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editTimeSlot(timeSlotEvent, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/add-time-slot-dialog.html').default,
      controller: function ($scope, commonsConstants) {

        $scope.header = 'Edit Time Slot';
        $scope.action = 'Update';

        $scope.days = commonsConstants.dayArray;
        $scope.timeSlot = angular.copy(timeSlotEvent);

        $scope._getHour = (hour, minute) => {
          return ("0" + hour).slice(-2) + ':' + ("0" + minute).slice(-2);
        }

        $scope._getTimeStamp = (hour, min, day) => {
          return self.moment().day(day).set({'hour': hour, 'minute': min, 'second': 0, 'millisecond': 0}).valueOf();
        }

        $scope._getDurationInMillis = () => {
          return $scope._getTimeStamp($scope.selectedTime.toHour, $scope.selectedTime.toMinute, $scope.selectedDays.to) - $scope._getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
        }

        const currentDayIndexFrom = timeSlotEvent.startHour ?
          self.moment($scope._getTimeStamp(timeSlotEvent.startHour, timeSlotEvent.startMinute, _.head(timeSlotEvent.byWeekDay || []))).day() :
          self.moment(timeSlotEvent.startTime).day();
        const currentDayIndexTo = timeSlotEvent.startHour ?
          self.moment($scope._getTimeStamp(timeSlotEvent.startHour, timeSlotEvent.startMinute, _.head(timeSlotEvent.byWeekDay || [])) + timeSlotEvent.totalDurationInMillis).day() :
          self.moment(timeSlotEvent.endTime).day();

        $scope.timeSlotOptions = {
          hours: [],
          minutes: [0, 30]
        };

        //Hours
        for (let hour = 0; hour <= 23; hour++) {
          $scope.timeSlotOptions.hours.push(hour);
        }

        $scope.selectedDays = {
          from: $scope.days[currentDayIndexFrom],
          to: $scope.days[currentDayIndexTo]
        };
        $scope.selectedTime = {
          fromHour: timeSlotEvent.startHour ? timeSlotEvent.startHour : self.moment(timeSlotEvent.startTime).hour(),
          fromMinute: timeSlotEvent.startHour ? timeSlotEvent.startMinute : self.moment(timeSlotEvent.startTime).minute(),
          toHour: timeSlotEvent.startHour ? self.moment($scope._getTimeStamp(timeSlotEvent.startHour, timeSlotEvent.startMinute, _.head(timeSlotEvent.byWeekDay || [])) + timeSlotEvent.totalDurationInMillis).hour() : self.moment(timeSlotEvent.endTime).hour(),
          toMinute: timeSlotEvent.startHour ? self.moment($scope._getTimeStamp(timeSlotEvent.startHour, timeSlotEvent.startMinute, _.head(timeSlotEvent.byWeekDay || [])) + timeSlotEvent.totalDurationInMillis).minute() : self.moment(timeSlotEvent.endTime).minute()
          // fromHour: moment(timeSlotEvent.startTime).hour(),
          // fromMinute: moment(timeSlotEvent.startTime).minute(),
          // toHour: moment(timeSlotEvent.endTime).hour(),
          // toMinute: moment(timeSlotEvent.endTime).minute()
        };

        $scope.multiplDays = {
          enabled: currentDayIndexFrom != currentDayIndexTo
        };

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.timeValidationCheck = () => {
          if (!$scope.multiplDays.enabled) {
            $scope.selectedDays.to = $scope.selectedDays.from;
          }

          const fromDay = self.moment().day($scope.selectedDays.from);
          const toDay = self.moment().day($scope.selectedDays.to);

          if (!$scope.multiplDays.enabled || fromDay >= toDay) {
            if ($scope.selectedTime.fromHour > $scope.selectedTime.toHour ||
              (_.isEqual($scope.selectedTime.fromHour, $scope.selectedTime.toHour) && $scope.selectedTime.fromMinute > $scope.selectedTime.toMinute)) {
              $scope.selectedTime.toHour = $scope.selectedTime.fromHour;
              $scope.selectedTime.toMinute = $scope.selectedTime.fromMinute;
            }
          }

        }

        $scope.onMultipleDaysChange = (enabled) => {
          $scope.selectedDays.to = $scope.selectedDays.from;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              $scope.timeSlot.startRecurring = $scope._getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
              $scope.timeSlot.startHour = $scope.selectedTime.fromHour;
              $scope.timeSlot.startMinute = $scope.selectedTime.fromMinute;
              $scope.timeSlot.totalDurationInMillis = $scope._getDurationInMillis();
              $scope.timeSlot.byWeekDay = [$scope.selectedDays.from.substring(0, 2)];

              // $scope.timeSlot.start = _getHour($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute);
              // $scope.timeSlot.end = _getHour($scope.selectedTime.toHour, $scope.selectedTime.toMinute);
              // $scope.timeSlot.startTime = _getTimeStamp($scope.selectedTime.fromHour, $scope.selectedTime.fromMinute, $scope.selectedDays.from);
              // $scope.timeSlot.endTime = _getTimeStamp($scope.selectedTime.toHour, $scope.selectedTime.toMinute, $scope.selectedDays.to);

              self.$mdDialog.hide($scope.timeSlot);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  duplicateTimeSlot(originalTimeSlot, isParent, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/duplicate-time-slot-dialog.html').default,
      controller: function ($scope, $mdSelect, commonsConstants) {

        $scope.timeSlot = angular.copy(originalTimeSlot);
        $scope.daysMap = commonsConstants.daysMap;
        $scope.selectedDays = originalTimeSlot.byWeekDay;

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onCloseSelect = () => {
          $mdSelect.hide();
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              const daysToAdd =
                _.chain($scope.selectedDays)
                  .filter((day) => {
                    if (isParent) {
                      return true;
                    }
                    var dayShort = day.substring(0, 2);
                    return _.indexOf(originalTimeSlot.byWeekDay, dayShort) === -1;
                  })
                  .map((d) => {
                    return d.substring(0, 2)
                  })
                  .value();

              const dayNumberMap = {
                'Su': 0,
                'Mo': 1,
                'Tu': 2,
                'We': 3,
                'Th': 4,
                'Fr': 5,
                'Sa': 6,
              };

              const timeSlotsToCreate = _.map(daysToAdd, (d) => {
                const timeSlot = angular.copy(originalTimeSlot);

                const dayNumber = dayNumberMap[d];
                const dayStartRecurring = self.moment().startOf('week').add(dayNumber, 'days');
                dayStartRecurring.hour(self.moment(timeSlot.startRecurring).hour());
                dayStartRecurring.minute(self.moment(timeSlot.startRecurring).minute());
                dayStartRecurring.second(self.moment(timeSlot.startRecurring).second());
                dayStartRecurring.millisecond(self.moment(timeSlot.startRecurring).millisecond());
                timeSlot.dow = [];
                timeSlot.byWeekDay = [d];
                timeSlot.startRecurring = dayStartRecurring.valueOf();
                return timeSlot;
              });
              self.$mdDialog.hide(timeSlotsToCreate);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  createAddition(event?, addition?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/create-addition-dialog.html').default,
      controller: function ($scope, splitService) {

        $scope.header = addition ? 'Update Addition' : 'Create Addition';
        $scope.action = addition ? 'Update' : 'Create';

        $scope.addition = addition ? angular.copy(addition) : {};
        $scope.currencySymbol = splitService.getCurrencySymbol();

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onAdditionTypeChange = (type) => {
          $scope.addition.type = type;
        }

        $scope.submit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.addition);
            }

          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectAddition(originalIds, event) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-addition-dialog.html').default,
      controller: function ($scope) {

        $scope.originalIds = angular.copy(originalIds);
        $scope.selectedIds = [];

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onAdditionsChange = (additions) => {
          $scope.selectedAdditions = additions;
          $scope.selectedAdditionsIds = _.map(additions, 'id');
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.selectedAdditions);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectAreaDialog(event, areas, selectedPickups, selectedDropoffs) {
    const deferred = this.$q.defer();
    const self = this;
    const dialog = {
      template: require('./../views/dialogs/select-areas-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      controller: ['$scope', function ($scope) {
        $scope.pickupAreasList = angular.copy(areas);
        $scope.dropoffsAreasList = angular.copy(areas);
        $scope.selectedPickups = angular.copy(selectedPickups);
        $scope.selectedDropoffs = angular.copy(selectedDropoffs);
        $scope.isLoading = false;
        $scope.doSearchByGeoLocation = false;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.done = () => {
          self.$mdDialog.hide({
            selectedPickups: $scope.selectedPickups,
            selectedDropoffs: $scope.selectedDropoffs
          });
        }

        $scope.switchAreas = () => {
          const pickupsCopy = angular.copy($scope.selectedPickups);
          $scope.selectedPickups = angular.copy($scope.selectedDropoffs);
          $scope.selectedDropoffs = pickupsCopy;
        }

      }]
    };

    this.uiGmapGoogleMapApi.then(
      () => {
        this.$mdDialog.show(dialog).then(deferred.resolve, deferred.reject);
      },
      deferred.reject
    );

    return deferred.promise;
  }

  editPricePlanAreaByDistanceConfiguration(event, zone) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-price-plan-area-configuration-by-distance-dialog.tmpl.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.isLoading = false;
        $scope.zone = angular.copy(zone);
        $scope.maxFieldInvalid = false;

        $scope.cancel = self.$mdDialog.cancel;

        $scope.update = () => {
          if ($scope.validateMinMax()) {
            $scope.maxFieldInvalid = false;
            self.$mdDialog.hide($scope.zone);
            // $scope.doUpdate();
          } else {
            $scope.maxFieldInvalid = true;
          }
        }

        $scope.linkToParent = () => {
          _.unset($scope, 'zone.basePrice');
          _.unset($scope, 'zone.maxPrice');
          _.unset($scope, 'zone.discount');
          _.unset($scope, 'zone.commission');
          _.unset($scope, 'zone.basePriceRange');
          $scope.doUpdate();
        }

        $scope.validateMinMax = () => {
          const min = $scope.zone.basePrice || $scope.zone.parentBasePrice || 0,
            max = $scope.zone.maxPrice || $scope.zone.parentMaxPrice || 0;
          return min <= max;
        }


      }
    });
  }

  editPricePlanQuantityDiscountLines(event, quantityDiscountLines) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/edit-price-plan-quantity-discount-lines-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.isLoading = false;
        $scope.quantityDiscountLines = angular.copy(quantityDiscountLines);

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.addQuantitySettingLine = () => {
          let lastLine: any = _.last($scope.quantityDiscountLines);
          const quantitySettingLine = {
            from: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 1 : 0,
            to: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 2 : 10,
            type: 'Discount',
            value: 0
          }
          $scope.quantityDiscountLines.push(quantitySettingLine);
        }

        $scope.onAmountChange = (quantitySetting, index) => {
          if (!_.isUndefined(quantitySetting.from) && $scope.quantityDiscountLines[index - 1]) {
            $scope.quantityDiscountLines[index - 1].to = quantitySetting.from - 1;
          }
          if (!_.isUndefined(quantitySetting.to) && $scope.quantityDiscountLines[index + 1]) {
            $scope.quantityDiscountLines[index + 1].from = quantitySetting.to + 1;
          }
        }

        $scope.onRemove = (index) => {
          $scope.quantityDiscountLines.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide($scope.quantityDiscountLines);
            }
          }
        }


      }
    });
  }

  bulkEditPackages(packagesOptionsIds, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-packages-dialog.html').default,
      controller: function ($scope) {

        $scope.currency = self.splitService.getCurrencySymbol();
        $scope.packagesOptionsIds = packagesOptionsIds || [];
        $scope.selectedPackagesIds = [];

        $scope.programState = 'NO_CHANGE';

        $scope.sumType = "+";
        $scope.isPercent = false;
        $scope.price = undefined;

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onSelectedPackagesIdsChange = (packageIds) => {
          $scope.selectedPackagesIds = packageIds;
        }

        $scope.onChangePackageState = (programState) => {
          $scope.programState = programState;
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide({
            packagesIds: $scope.selectedPackagesIds,
            sumType: $scope.sumType,
            isPercent: $scope.isPercent,
            price: $scope.price,
            programState: $scope.programState
          });
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  bulkEditLocationPackages(location, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/bulk-edit-location-packages-dialog.html').default,
      controller: function ($scope) {

        $scope.location = angular.copy(location);
        $scope.packagesOptionsIds = [];
        _.forOwn(location.combinedPackageSizePriceDataMap, (value, key) => {
          $scope.packagesOptionsIds.push(key);
        })
        $scope.selectedPackagesIds = [];

        $scope.programState = 'NO_CHANGE';
        $scope.basePrice = undefined;

        $scope.quantitySettingsOptions = ['DEFAULT', 'CUSTOM', 'PARENT'];
        $scope.quantitySettingsValue = 'NO_CHANGE';

        $scope.quantityDiscountLines = [];

        $scope.cancel = self.$mdDialog.cancel;
        /////////////////////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onSelectedPackagesIdsChange = (packageIds) => {
          $scope.selectedPackagesIds = packageIds;
        }

        $scope.onChangePackageState = (programState) => {
          $scope.programState = programState;
        }

        $scope.onQuantitySettingsChange = (quantitySettingsValue) => {
          $scope.quantitySettingsValue = quantitySettingsValue;
          $scope.quantityDiscountLines = quantitySettingsValue === 'CUSTOM' ? [] : undefined;
        }

        $scope.addQuantitySettingLine = () => {
          let lastLine: any = _.last($scope.quantityDiscountLines);
          const quantitySettingLine = {
            from: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 1 : 0,
            to: !_.isUndefined(_.get(lastLine, 'to')) ? lastLine.to + 2 : 10,
            type: 'Discount',
            value: 0
          }
          $scope.quantityDiscountLines.push(quantitySettingLine);
        }

        $scope.onAmountChange = (quantitySetting, index) => {
          if (!_.isUndefined(quantitySetting.from) && $scope.quantityDiscountLines[index - 1]) {
            $scope.quantityDiscountLines[index - 1].to = quantitySetting.from - 1;
          }
          if (!_.isUndefined(quantitySetting.to) && $scope.quantityDiscountLines[index + 1]) {
            $scope.quantityDiscountLines[index + 1].from = quantitySetting.to + 1;
          }
        }

        $scope.onRemoveQuantityDiscountLine = (index) => {
          $scope.quantityDiscountLines.splice(index, 1);
        }

        $scope.onSubmit = () => {
          const programState = $scope.programState === 'undefined' ? undefined : $scope.programState;
          _.forEach($scope.selectedPackagesIds, (id) => {
            if (programState !== 'NO_CHANGE') {
              $scope.location.combinedPackageSizePriceDataMap[id].enabled = programState;
            }
            if (!!$scope.basePrice) {
              $scope.location.combinedPackageSizePriceDataMap[id].basePrice = $scope.basePrice;
            }

            if ($scope.quantitySettingsValue !== 'NO_CHANGE') {

              if (!$scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings) {
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings = {};
              }

              if ($scope.quantitySettingsValue === 'CUSTOM') {

                if (!$scope.location.combinedPackageSizePriceDataMap[id].quantitySetting) {
                  $scope.location.combinedPackageSizePriceDataMap[id].quantitySetting = {};
                }

                $scope.location.combinedPackageSizePriceDataMap[id].quantitySetting.quantityDiscountLines = $scope.quantityDiscountLines;
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsParent = false;
              } else if ($scope.quantitySettingsValue === 'PARENT') {
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsParent = true;
              } else if ($scope.quantitySettingsValue === 'DEFAULT') {
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsDefault = true;
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsParent = false;
              } else {
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsDefault = false;
                $scope.location.combinedPackageSizePriceDataMap[id].packageSizeSettings.packageSizeQuantitySettingsParent = false;
              }
            }
          })

          self.$mdDialog.hide($scope.location);
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }


  addBulkLocations(event, location, excludeIds?) {
    const self = this;
    return this.$mdDialog.show({
      template: require('./../views/dialogs/add-bulk-locations-dialog.html').default,
      parent: angular.element(document.body),
      targetEvent: event,
      clickOutsideToClose: true,
      fullscreen: true,
      controller: function ($scope) {

        $scope.location = angular.copy(location);
        $scope.excludeIds = angular.copy(excludeIds);

        $scope.programLocationTypes = self.programLocationTypes;
        $scope.locationType = self.programLocationTypes.ACCOUNT;
        $scope.selectedIds = [];
        $scope.selectedEntities = [];

        $scope.cancel = self.$mdDialog.cancel;

        /////////////////////////////////

        $scope.onLocationTypeChange = (locationType) => {
          $scope.locationType = locationType;
          $scope.selectedIds = [];
          $scope.selectedEntities = [];
        }

        $scope.onSelect = (selectedEntities, ids) => {
          $scope.selectedIds = ids;
          $scope.selectedEntities = selectedEntities;
        }

        $scope.onRemove = (index) => {
          $scope.quantityDiscountLines.splice(index, 1);
        }

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);
            if (form.$valid) {
              self.$mdDialog.hide({entityType: $scope.locationType, entities: $scope.selectedEntities});
            }
          }
        }


      }
    });
  }


  createServiceValidation(event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/service-validation-dialog.html').default,
      controller: function ($scope) {

        $scope.action = 'Create';

        $scope.validation = {
          name: undefined,
          validationLevel: undefined,
          fieldValidation: undefined,
          mandatory: false
        };

        $scope.validationLevelOptions = Object.values(ServiceValidationLevel);

        $scope.initFieldValidationOptions = (level: ServiceValidationLevel) => {
          if (level === ServiceValidationLevel.Task) {
            $scope.fieldValidationOptions = [ServiceFieldValidation.General, ServiceFieldValidation.TotalQuantity, ServiceFieldValidation.ProNumber, ServiceFieldValidation.ExternalId];
          } else {
            $scope.fieldValidationOptions = [ServiceFieldValidation.General, ServiceFieldValidation.Barcode, ServiceFieldValidation.PackageQuantity];
          }
        }

        $scope.onSelectLevel = (level) => {
          $scope.validation.validationLevel = level;
          $scope.validation.fieldValidation = undefined;
          $scope.initFieldValidationOptions($scope.validation.validationLevel);
        }

        $scope.onSelectFieldValidation = (validation) => {
          $scope.validation.fieldValidation = validation;
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.validation);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  editServiceValidation(serviceValidation: ServiceValidationTemplateModel, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/service-validation-dialog.html').default,
      controller: function ($scope) {

        $scope.action = 'Edit';
        $scope.validation = serviceValidation

        $scope.validationLevelOptions = Object.values(ServiceValidationLevel);

        $scope.initFieldValidationOptions = (level: ServiceValidationLevel) => {
          if (level === ServiceValidationLevel.Task) {
            $scope.fieldValidationOptions = [ServiceFieldValidation.General, ServiceFieldValidation.TotalQuantity, ServiceFieldValidation.ProNumber, ServiceFieldValidation.ExternalId];
          } else {
            $scope.fieldValidationOptions = [ServiceFieldValidation.General, ServiceFieldValidation.Barcode, ServiceFieldValidation.PackageQuantity];
          }
        }

        $scope.initFieldValidationOptions($scope.validation.validationLevel);

        $scope.onSelectLevel = (level) => {
          $scope.validation.validationLevel = level;
          $scope.validation.fieldValidation = undefined;
          $scope.initFieldValidationOptions($scope.validation.validationLevel);
        }

        $scope.onSelectFieldValidation = (validation) => {
          $scope.validation.fieldValidation = validation;
        }

        $scope.cancel = self.$mdDialog.cancel;

        // ******************************
        // External methods
        // ******************************

        $scope.onSubmit = (form) => {
          if (form) {
            form.$setSubmitted(true);

            if (form.$valid) {
              self.$mdDialog.hide($scope.validation);
            }
          }
        }

      },
      targetEvent: event,
      clickOutsideToClose: true
    })
  }

  selectServiceValidation(serviceValidations, selectedIds?, event?) {
    const self = this;
    return this.$mdDialog.show({
      parent: angular.element(document.body),
      template: require('./../views/dialogs/select-service-validation-dialog.html').default,
      controller: function ($scope) {

        $scope.excludedIds = selectedIds;
        $scope.selectedIds = [];

        $scope.optionsWrapper = {
          list: serviceValidations?.map(s => {
            return {id: s.id, name: s.name}
          }), propertyRef: 'name'
        };

        $scope.cancel = self.$mdDialog.cancel;
        //////////////////////////////////////

        // ******************************
        // Public methods
        // ******************************

        $scope.onMultiSelect = (ids) => {
          $scope.selectedIds = ids;
        }

        $scope.onSelect = (id) => {
          $scope.selectedIds = [id];
        }

        $scope.onSubmit = () => {
          self.$mdDialog.hide($scope.selectedIds);
        }

      },
      targetEvent: event,
      fullscreen: true,
      clickOutsideToClose: false
    })
  }


}

angular
  .module('bringoz.admin.pricePlan')
  .service('pricePlanDialogService', PricePlanDialogService);
